<template>
  <scroll-layout class="royalty-strategy-apply-detail">
    <template slot="header">
      <div class="btn-wrap">
        <div class="button-wrap">
          <ykc-button type="plain" @click="goBack">返回</ykc-button>
        </div>
        <div class="button-wrap">
          <template v-if="Number(detail.status) === 1">
            <el-button
              v-if="code('operation:price:rake:apply:approve')"
              type="primary"
              size="small"
              @click="doApprove">
              通过
            </el-button>
            <el-button
              v-if="code('operation:price:rake:apply:reject')"
              type="danger"
              size="small"
              @click="doReject">
              不通过
            </el-button>
            <el-button
              v-if="code('operation:price:rake:apply:revoke')"
              type="warning"
              size="small"
              @click="doRevoke">
              撤销
            </el-button>
          </template>
        </div>
      </div>
    </template>
    <div>
      <!-- 申请信息 -->
      <ykc-detail :tips="true" :isLine="true" :titles="['申请信息']" :className="'all mgt20'">
        <div slot="cvBody">
          <div class="form-detail">
            <ykc-form :label-position="'left'" label-width="130px" class="form-left">
              <ykc-detail-item label="申请编码：">
                <span>{{ detail.applyNo || '——' }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="提交人：">
                <span>{{ detail.submitName || '——' }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="审核人：">
                <span>{{ detail.auditName || '——' }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="状态：">
                <span>{{ detail.statusDesc || '——' }}</span>
              </ykc-detail-item>
            </ykc-form>
            <ykc-form :label-position="'left'" label-width="130px" class="form-right">
              <ykc-detail-item label="电站名称：">
                <span>{{ detail.stationName || '——' }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="提交时间：">
                <span>{{ detail.submitTime || '——' }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="审核时间：">
                <span>{{ (detail.status !== 5 && detail.auditTime) || '——' }}</span>
              </ykc-detail-item>
            </ykc-form>
          </div>
        </div>
      </ykc-detail>

      <div class="info-wrap">
        <div class="info-wrap-left" v-if="Number(detail.status) === 1">
          <!-- 生效中信息 -->
          <div>生效中信息</div>
          <!-- effectiveCollectFlag=0 时仅展示「无分成方」，不展示物业 -->
          <ykc-detail
            v-if="detail.effectiveCollectFlag === '0'"
            :tips="true"
            :isLine="true"
            :titles="['分成方信息']"
            :className="'all mgt20'">
            <div slot="cvBody">
              <span>无分成方</span>
            </div>
          </ykc-detail>
          <template v-else>
            <ykc-detail
              :tips="true"
              :isLine="true"
              :titles="['物业：' + (detail.effectiveProperty?.propertyName || '--')]"
              :className="'all mgt20'">
              <div slot="cvBody">
                <div class="form-detail">
                  <ykc-form :label-position="'left'" label-width="130px" class="form-left">
                    <ykc-detail-item label="电费抽成：">
                      <span>
                        {{
                          formatPropertyRate(
                            detail.effectiveProperty?.powerRate,
                            detail.effectiveProperty?.powerRateType
                          )
                        }}
                      </span>
                    </ykc-detail-item>
                  </ykc-form>
                  <ykc-form :label-position="'left'" label-width="130px" class="form-right">
                    <ykc-detail-item label="服务费抽成：">
                      <span>
                        {{
                          formatPropertyRate(
                            detail.effectiveProperty?.serviceRate,
                            detail.effectiveProperty?.serviceRateType
                          )
                        }}
                      </span>
                    </ykc-detail-item>
                  </ykc-form>
                </div>
              </div>
            </ykc-detail>

            <!-- 生效中-分成方 -->
            <ykc-detail
              v-if="!detail.effectivePartners || detail.effectivePartners.length === 0"
              :tips="true"
              :isLine="true"
              :titles="['分成方信息']"
              :className="'all mgt20'">
              <div slot="cvBody">
                <span>无分成方</span>
              </div>
            </ykc-detail>
            <ykc-detail
              v-for="(partner, idx) in detail.effectivePartners || []"
              :key="'eff-p-' + idx"
              :tips="true"
              :isLine="true"
              :titles="['分成方' + (idx + 1) + '：' + (partner.partnerName || '——')]"
              :className="'all mgt20'">
              <div slot="cvBody">
                <div class="form-detail">
                  <ykc-form :label-position="'left'" label-width="130px" class="form-left">
                    <ykc-detail-item label="服务费抽成：">
                      <span>
                        {{ formatPartnerRate(partner.serviceRate, partner.serviceRateType) }}
                      </span>
                    </ykc-detail-item>
                  </ykc-form>
                  <ykc-form :label-position="'left'" label-width="130px" class="form-right">
                    <ykc-detail-item label="年费抽成：">
                      <span>{{ partner.annualFee || '0' }}元/年</span>
                    </ykc-detail-item>
                  </ykc-form>
                </div>
              </div>
            </ykc-detail>
          </template>
        </div>
        <div class="info-wrap-right">
          <div>申请信息</div>
          <!-- collectFlag=0 时仅展示「清空分成方」，不展示物业 -->
          <ykc-detail
            v-if="detail.collectFlag === '0'"
            :tips="true"
            :isLine="true"
            :titles="['分成方信息']"
            :className="'all mgt20'">
            <div slot="cvBody">
              <span>清空分成方</span>
            </div>
          </ykc-detail>
          <template v-else>
            <!-- 物业 -->
            <ykc-detail
              :tips="true"
              :isLine="true"
              :titles="['物业：' + (detail.property?.propertyName || '--')]"
              :className="'all mgt20'">
              <div slot="cvBody">
                <div class="form-detail">
                  <ykc-form :label-position="'left'" label-width="130px" class="form-left">
                    <ykc-detail-item label="电费抽成：">
                      <span>
                        {{
                          formatPropertyRate(
                            detail.property?.powerRate,
                            detail.property?.powerRateType
                          )
                        }}
                      </span>
                    </ykc-detail-item>
                  </ykc-form>
                  <ykc-form :label-position="'left'" label-width="130px" class="form-right">
                    <ykc-detail-item label="服务费抽成：">
                      <span>
                        {{
                          formatPropertyRate(
                            detail.property?.serviceRate,
                            detail.property?.serviceRateType
                          )
                        }}
                      </span>
                    </ykc-detail-item>
                  </ykc-form>
                </div>
              </div>
            </ykc-detail>

            <!-- 分成方 -->
            <ykc-detail
              v-if="!detail.partners || detail.partners.length === 0"
              :tips="true"
              :isLine="true"
              :titles="['分成方信息']"
              :className="'all mgt20'">
              <div slot="cvBody">
                <span>无分成方</span>
              </div>
            </ykc-detail>
            <ykc-detail
              v-for="(partner, idx) in detail.partners || []"
              :key="'apply-p-' + idx"
              :tips="true"
              :isLine="true"
              :titles="['分成方' + (idx + 1) + '：' + (partner.partnerName || '--')]"
              :className="'all mgt20'">
              <div slot="cvBody">
                <div class="form-detail">
                  <ykc-form :label-position="'left'" label-width="130px" class="form-left">
                    <ykc-detail-item label="服务费抽成：">
                      <span>
                        {{ formatPartnerRate(partner.serviceRate, partner.serviceRateType) }}
                      </span>
                    </ykc-detail-item>
                  </ykc-form>
                  <ykc-form :label-position="'left'" label-width="130px" class="form-right">
                    <ykc-detail-item label="年费抽成：">
                      <span>{{ partner.annualFee || '0' }}元/年</span>
                    </ykc-detail-item>
                  </ykc-form>
                </div>
              </div>
            </ykc-detail>
          </template>
        </div>
      </div>
    </div>
  </scroll-layout>
</template>

<script>
  import { commissionStrategy } from '@/service/apis';
  import YkcDialog from '@/components/ykc-ui/dialog';
  import { code } from '@/utils';

  export default {
    name: 'RoyaltyStrategyApplyDetail',
    data() {
      return {
        applyId: null,
        detail: {},
      };
    },
    created() {
      this.applyId = this.$route.query.applyId;
      if (this.applyId) {
        this.fetchDetail();
      }
    },
    methods: {
      code,
      fetchDetail() {
        commissionStrategy.applyGetDetail({ applyId: this.applyId }).then(res => {
          this.detail = res || {};
        });
      },
      formatRate(rate, type) {
        if (!rate && rate !== 0) return '0';
        return `${rate}${this.getUnit(type)}`;
      },
      formatPropertyRate(rate, type) {
        if (!rate && rate !== 0) return '0';
        const unitMap = { 1: '元/度', 2: '%', 3: '元/时', 4: '元/次' };
        const unit = unitMap[type] || '';
        return `${rate}${unit}`;
      },
      formatPartnerRate(rate, type) {
        if (!rate && rate !== 0) return '0';
        const unitMap = { 1: '元/度', 2: '%' };
        const unit = unitMap[type] || '';
        return `${rate}${unit}`;
      },
      getUnit(type) {
        const typeMap = { 1: '度数', 2: '比例', 3: '小时', 4: '次数' };
        return typeMap[type] || '';
      },
      goBack() {
        this.$router.go(-1);
      },
      doApprove() {
        YkcDialog({
          dialogType: 'feedback',
          showTitle: false,
          showFooter: true,
          desc: `确认通过申请「${this.detail.applyNo}」？通过后该电站抽成策略将立即生效。`,
          onCancel: done => {
            done();
          },
          onConfirm: done => {
            commissionStrategy
              .applyApprove(this.applyId)
              .then(() => {
                this.$message.success('审核通过');
                done();
                this.fetchDetail();
              })
              .catch(() => {
                done();
              });
          },
        });
      },
      doReject() {
        YkcDialog({
          dialogType: 'feedback',
          showTitle: false,
          showFooter: true,
          desc: `确认审核不通过申请「${this.detail.applyNo}」？`,
          onCancel: done => {
            done();
          },
          onConfirm: done => {
            commissionStrategy
              .applyReject(this.applyId)
              .then(() => {
                this.$message.success('已审核不通过');
                done();
                this.fetchDetail();
              })
              .catch(() => {
                done();
              });
          },
        });
      },
      doRevoke() {
        YkcDialog({
          dialogType: 'feedback',
          showTitle: false,
          showFooter: true,
          desc: `确认撤销申请「${this.detail.applyNo}」？`,
          onCancel: done => {
            done();
          },
          onConfirm: done => {
            commissionStrategy
              .applyRevoke(this.applyId)
              .then(() => {
                this.$message.success('已撤销');
                done();
                this.fetchDetail();
              })
              .catch(() => {
                done();
              });
          },
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .list-item {
    border-bottom: 1px dashed #f1f0f0;
    box-sizing: border-box;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .detail-left {
      .detail-title {
        font-size: 12px;
        display: flex;

        .tag {
          background: #fff2e0;
          color: #ff5521;
          font-size: 16px;
          transform: scale(0.5);
          padding: 1px 8px;
          transform-origin: left;
          margin-left: 10px;
          margin-top: -6px;
          .coupon {
            font-size: 22px;
          }
        }
      }

      .detail-tips {
        text-align: left;

        div {
          color: #9b9b9b;
          font-size: 12px;
          transform: scale(0.83);
          transform-origin: left;
          margin-top: 4px;
        }

        .blank {
          color: #000000;
          font-weight: 400;
        }

        .space {
          margin-left: 20px;
        }

        .blue {
          color: #4d8cfd;
          font-weight: 400;
        }
      }
    }

    .detail-right {
      .money {
        font-size: 12px;
        color: #000000;

        div {
          display: inline-block;

          p {
            margin: 0;
          }
        }

        .left-money {
          text-align: right;
          margin-right: 4px;
        }

        .right-money {
          color: #9b9b9b;
          text-align: left;
          margin-left: 4px;
        }
      }

      .totla {
        font-size: 14px;
        color: #000000;
        font-weight: 600;
      }

      .totla-blue {
        font-size: 14px;
        color: #4d8cfd;
        font-weight: 600;
      }
    }

    .emphasize {
      font-weight: 600;
    }
  }
  .info-wrap {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    .info-wrap-left {
      flex: 1;
      overflow: hidden;
      margin-right: 20px;
    }
    .info-wrap-right {
      flex: 1;
      overflow: hidden;
    }
  }

  .button-wrap {
    display: flex;
    align-items: center;
    gap: 12px;
    &.right {
      margin-left: auto;
    }
  }
  .form-detail {
    display: flex;
    .form-left,
    .form-right {
      flex: 1;
    }
  }
  .btn-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
</style>
<style>
  .mgt20 {
    margin-top: 20px;
  }
</style>
